module.exports = __webpack_public_path__ + "static/assets/8ca9997e9ed7534a8d0f349a6125bd24.mp3";